export var ExportError;
(function (ExportError) {
})(ExportError || (ExportError = {}));
export var Format;
(function (Format) {
    Format["pdf"] = "pdf";
    Format["csv"] = "csv";
    Format["xls"] = "xls";
})(Format || (Format = {}));
var ExportRequest = /** @class */ (function () {
    function ExportRequest(id, format, custom, reportSettings, historizedQuery) {
        this.knownErrorCodes = Object.values(ExportError);
        this.method = 'post';
        this.path = "".concat(custom ? 'my/customized-' : '', "reports/").concat(encodeURIComponent(id), "/export-").concat(format, "?").concat(String(historizedQuery.searchParams));
        this.body = JSON.stringify(reportSettings);
    }
    return ExportRequest;
}());
export { ExportRequest };
